import type { ProgressReportStore } from './interfaces'

export const createInitialState = (): ProgressReportStore => ({
  listById: {},
  reportById: {},
  newById: {},
})
